import { RequirementDisplay } from '../../../../../../shared/frontend/scripts/recruitment/utils';
import { RAID_METADATA_BY_SLUG } from '../../../../shared/enums';

export const { getRequirementHighlights, isRequirementComplete, buildDisplay } = new RequirementDisplay(
  RAID_METADATA_BY_SLUG
);
